import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
  query insuranceCompaniesActive {
    insuranceCompaniesActive {
      id
      name
      is_active
      status_text
    }
  }
`

const GET_WITH_PAGINATION = gql`
  query insuranceCompaniesWithPagination($page: Int, $perPage: Int) {
    insuranceCompaniesWithPagination(page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        name
        is_active
        status_text
      }
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createInsuranceCompany($input: InsuranceCompanyForm!) {
    createInsuranceCompany(input: $input) {
      id
      name
      is_active
      status_text
    }
  }
`

const UPDATE = gql`
  mutation updateInsuranceCompany($id: ID!, $input: InsuranceCompanyForm!) {
    updateInsuranceCompany(id: $id, input: $input) {
      id
      name
      is_active
      status_text
    }
  }
`

const DELETE = gql`
  mutation deleteInsuranceCompany($id: ID!) {
    deleteInsuranceCompany(id: $id) {
      id
      name
      is_active
      status_text
    }
  }
`

export { ALL_ACTIVE, GET_WITH_PAGINATION, CREATE, UPDATE, DELETE }
